import { gql } from '@apollo/client';

export const UPDATE_COMMUNITY_POLICY = gql`
  mutation UpdateCommunityPolicy($communityId: ID!, $policyId: ID!, $input: UpdatePolicyInput!) {
    updatePolicy(communityId: $communityId, policyId: $policyId, input: $input) {
      id
      communityId
      name
      description
      isEnabled
      labels {
        labelId
        severity
        scoreThreshold
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
